'use strict';
define(['jquery'], function () {
    return {
        templateUrl: 'app/components/access-components/st-tailor-made/st-tailor-made.html',
        bindings: {
            redirectTo: '<'
        },
        controller: ['$window', '$scope', '$state', '$stateParams', '$filter', '$translate', 'UserService', 'TrackEventService', 'CountriesService', 'LanguageService', '$mdMedia', 'UtilitiesService', 'PlanDetailsService',
            function ($window, $scope, $state, $stateParams, $filter, $translate, UserService, TrackEventService, CountriesService, LanguageService, $mdMedia, UtilitiesService, PlanDetailsService) {
                var vm = $scope;
                var currentLang = LanguageService.getCodeAndCountrySaveOnStorage();
                var defaultDialCode = CountriesService.getDialCodeByCountryCode(currentLang.split('-')[1]);
                vm.$mdMedia = $mdMedia;

                UserService.accountInfo()
                    .then(function (res) {
                        vm.data = {
                            signupInfo: {
                                businessType: res.data.businessType || null,
                                jobTitle: res.data.jobTitle || null,
                                acceptedReceiveOnboardingEmailAt: $filter('date')(res.data.acceptedReceiveOnboardingEmailAt, 'yyyy-MM-dd HH:mm:ss') || null,
                                domain: res.data.domain || null,
                                billingPhone: res.data.billingPhone || null,
                                billingPhonePrefix: res.data.billingPhonePrefix || defaultDialCode,
                                teamMembers: res.data.teamMembers || null,
                                lastLogin: $filter('date')(new Date().getTime(), 'yyyy-MM-dd HH:mm:ss')
                            },
                        };

                        if (vm.data.signupInfo.acceptedReceiveOnboardingEmailAt) {
                            vm.newsletterCheckbox = true;
                        }
                        return res.data;
                    })
                    .catch(function () {
                        return {};
                    });

                var ctrl = this;

                vm.signupInfo = signupInfo;
                vm.loading = false;
                vm.loadingPlans = false;
                vm.profileStep = 1;
                vm.billingInterval = 'year';
                vm.maxAnnualDiscount = 33;
                vm.planOptions = [];
                vm.isPromoTime = PlanDetailsService.isPromoTime();
                vm.currentPromo = vm.isPromoTime ? PlanDetailsService.getCurrentPromo() : null;

                vm.businessTypesOptions = UtilitiesService.getBusinessTypesOptions();
                vm.jobsTitleOptions = UtilitiesService.getJobsTitleOptions();
                vm.teamMembersOptions = UtilitiesService.getTeamMembersOptions();
                vm.nextProfileStep = nextProfileStep;
                vm.previousProfileStep = previousProfileStep;
                vm.isSiteStepValid = isSiteStepValid;
                vm.setBillingInterval = setBillingInterval;
                vm.selectPlan = selectPlan;
                vm.planPrice = planPrice;
                vm.planPriceBeforePromo = planPriceBeforePromo;
                vm.planAnnualTotal = planAnnualTotal;
                vm.planMonthlyTotal = planMonthlyTotal;
                vm.formatPlanPrice = formatPlanPrice;
                vm.formatPlanPriceBeforePromo = formatPlanPriceBeforePromo;
                vm.formatPlanAnnualTotal = formatPlanAnnualTotal;
                vm.promoAppliesToBilling = promoAppliesToBilling;
                vm.planName = planName;
                vm.formatNumber = formatNumber;
                vm.formatMetric = formatMetric;
                vm.isNumber = isNumber;
                vm.activatePlan = activatePlan;
                vm.continueToProject = continueToProject;
                vm.backToProfile = backToProfile;

                vm.updateNewsletterCheckbox = function (value) {
                    if (value) {
                        vm.data.signupInfo.acceptedReceiveOnboardingEmailAt = $filter('date')(new Date().getTime(), 'yyyy-MM-dd HH:mm:ss');
                    } else {
                        vm.data.signupInfo.acceptedReceiveOnboardingEmailAt = null;
                    }
                };

                vm.$watch('data.signupInfo.billingPhonePrefix', function (newVal) {
                    if (newVal && newVal.dial_code) {
                        vm.data.signupInfo.billingPhonePrefix = newVal.dial_code;
                    }
                });

                vm.$watch('data.signupInfo.businessType', function (businessType) {
                    $scope.$emit('onboardingReviewCategoryChanged', getReviewCategory(businessType));
                });

                function getReviewCategory(businessType) {
                    var categories = {
                        'E-commerce': 'E-Commerce',
                        'Digital Agency': 'Agency',
                        'Freelance': 'Freelance',
                        'Enterprise': 'Corporate',
                        'SMB': 'PMI',
                        'Blog': 'PMI',
                        'Newspaper': 'Corporate',
                        'Education': 'Corporate',
                        'Non-profit': 'Corporate',
                        'Other': 'PMI'
                    };
                    return categories[businessType] || null;
                }

                function nextProfileStep() {
                    if (isSiteStepValid()) {
                        vm.profileStep = 2;
                    }
                }

                function previousProfileStep() {
                    vm.profileStep = 1;
                }

                function backToProfile() {
                    vm.profileStep = 2;
                    $scope.$emit('onboardingStepChanged', 3);
                }

                function isSiteStepValid() {
                    if (!vm.data || !vm.data.signupInfo) {
                        return false;
                    }
                    var domain = vm.data.signupInfo.domain || '';
                    return /^(http:\/\/www\.|https:\/\/www\.|http:\/\/|https:\/\/)?[a-z0-9]+([\-\.]{1}[a-z0-9]+)*\.[a-z]{2,}(:[0-9]{1,})?(\/.*)?$/i.test(domain) &&
                        !!vm.data.signupInfo.teamMembers;
                }

                function signupInfo(form) {
                    if (vm.profileStep !== 2) {
                        return;
                    }
                    vm.loading = true;

                    /**
                     * Aggiungendo i Log bisogna distinguere le chiamate da dove partono
                     * e siccome sono tutte con lo stesso EndPoint diventa impossibile checkare tutto
                     * quindi creo typeCall per identificare da dove parte.
                     *
                     * @type {string}
                     */
                    // vm.data.signupInfo.typeCall = 'update-by-tailor-mode-data';
                    UserService.updateProfile(vm.data.signupInfo)
                        .then(function (res) {
                            TrackEventService.event('Funnel Events', 'Profiling Completed');
                            TrackEventService.gaV2Event('profile_complete');

                            if (vm.newsletterCheckbox) {
                                $window.localStorage.setItem('onboardingResponse', 'yes');
                            } else {
                                $window.localStorage.setItem('onboardingResponse', 'no');
                            }

                            if ($stateParams.workspaceId) {
                                $state.go('app.settings.invitations');
                            } else {
                                showPlanSelection();
                            }
                        })
                        .catch(function (err) {
                            console.log('err', err);
                            vm.loading = false;
                        });
                }

                function showPlanSelection() {
                    vm.profileStep = 3;
                    vm.loading = false;
                    vm.loadingPlans = false;
                    $scope.$emit('onboardingStepChanged', 4);
                    setPlanCatalog();
                }

                function setPlanCatalog() {
                    var selectedNames = getRecommendedPlanNames();
                    var effectivePlans = PlanDetailsService.getAll();

                    vm.planCatalog = effectivePlans
                        .filter(function (plan) {
                            return selectedNames.indexOf(plan.name) !== -1;
                        })
                        .map(preparePlanCard);
                    vm.planOptions = vm.planCatalog.slice();
                    vm.selectedPlan = vm.planCatalog.length > 1
                        ? vm.planCatalog[1].name
                        : (vm.planCatalog[0] && vm.planCatalog[0].name);
                    updateMaxAnnualDiscount(effectivePlans);
                    setBillingInterval(vm.billingInterval || 'year');
                }

                function getRecommendedPlanNames() {
                    var signupInfo = vm.data && vm.data.signupInfo || {};
                    var teamMembers = signupInfo.teamMembers || '';
                    var businessType = signupInfo.businessType || '';
                    var largeTeam = ['21-50', '51-100', '101-500', '501-1000', '1000+'].indexOf(teamMembers) !== -1;

                    if (businessType === 'Enterprise' || largeTeam) {
                        return ['Premium', 'Infinity'];
                    }
                    if (businessType === 'Freelance' || teamMembers === 'Just me') {
                        return ['Plus', 'Advanced'];
                    }
                    return ['Advanced', 'Premium'];
                }

                function preparePlanCard(plan) {
                    var features = plan.features && plan.features[0] || {};
                    var platform = features.platform || {};
                    var positionMonitoring = features.positionMonitoring || {};
                    var keywordResearch = features.keywordResearch || {};
                    var ai = features.ai || {};
                    var onSiteSeoAudit = features.onSiteSeoAudit || {};

                    return angular.extend({}, plan, {
                        cardLimits: [{
                            label: 'users',
                            value: platform.users
                        }, {
                            label: 'projects',
                            value: platform.projects
                        }, {
                            label: 'trackedKeyword',
                            value: positionMonitoring.trackedKeyword
                        }, {
                            label: 'resultsPerKeyword',
                            value: keywordResearch.resultsPerKeyword
                        }, {
                            label: 'websitesMonitorable',
                            value: platform.projects
                        }, {
                            label: 'crawl.credits.per.month',
                            value: onSiteSeoAudit.crawlablePagesPerMonth
                        }],
                        cardHighlights: [{
                            label: 'aiCredits',
                            value: ai.aiCredits
                        }]
                    });
                }

                function updateMaxAnnualDiscount(plans) {
                    vm.maxAnnualDiscount = plans.reduce(function (maximum, plan) {
                        if (!plan.monthlyAmount || !Number.isFinite(Number(plan.annualAmount))) {
                            return maximum;
                        }
                        var discount = Math.round((1 - Number(plan.annualAmount) / Number(plan.monthlyAmount)) * 100);
                        return Math.max(maximum, discount);
                    }, 0);
                }

                function setBillingInterval(interval) {
                    vm.billingInterval = interval === 'month' ? 'month' : 'year';
                }

                function selectPlan(planName) {
                    vm.selectedPlan = planName;
                }

                function planPrice(plan) {
                    if (!plan) {
                        return 0;
                    }
                    var amount = vm.billingInterval === 'year' ? plan.annualAmount : plan.monthlyAmount;
                    var decimal = vm.billingInterval === 'year'
                        ? plan.annualAmountDecimal
                        : plan.monthlyAmountDecimal;
                    return Number(amount) + (Number(decimal || 0) / 100);
                }

                function planPriceBeforePromo(plan) {
                    if (!plan || !promoAppliesToBilling()) {
                        return null;
                    }
                    return Number(plan.monthlyAmountBeforePromo || plan.monthlyAmount);
                }

                function planAnnualTotal(plan) {
                    if (!plan) {
                        return 0;
                    }
                    return (
                        Number(plan.annualAmount)
                        + (Number(plan.annualAmountDecimal || 0) / 100)
                    ) * 12;
                }

                function planMonthlyTotal(plan) {
                    return plan ? plan.monthlyAmount * 12 : 0;
                }

                function promoAppliesToBilling() {
                    return !!vm.currentPromo
                        && (!vm.currentPromo.annualOnly || vm.billingInterval === 'year');
                }

                function planName(plan) {
                    return plan && plan.name ? plan.name.replace('Plan ', '') : '';
                }

                function isNumber(value) {
                    return angular.isNumber(value);
                }

                function formatNumber(value) {
                    return formatLocalizedNumber(value, 0);
                }

                function formatPlanPrice(plan) {
                    return formatLocalizedNumber(planPrice(plan), promoAppliesToBilling() ? 2 : 0);
                }

                function formatPlanPriceBeforePromo(plan) {
                    return formatLocalizedNumber(planPriceBeforePromo(plan), 2);
                }

                function formatPlanAnnualTotal(plan) {
                    return formatLocalizedNumber(planAnnualTotal(plan), promoAppliesToBilling() ? 2 : 0);
                }

                function formatLocalizedNumber(value, fractionDigits) {
                    var locale = LanguageService.getCodeAndCountrySaveOnStorage() || 'en-US';
                    var options = {
                        minimumFractionDigits: fractionDigits,
                        maximumFractionDigits: fractionDigits
                    };
                    try {
                        return new Intl.NumberFormat(locale, options).format(Number(value));
                    } catch (error) {
                        return new Intl.NumberFormat('en-US', options).format(Number(value));
                    }
                }

                function formatMetric(value) {
                    var text = String(value);
                    if (typeof value === 'number' || /^-?\d+$/.test(text.trim())) {
                        return formatNumber(value);
                    }
                    var translated = $translate.instant(text);
                    return translated !== text ? translated : text;
                }

                function activatePlan(plan) {
                    var selectedPlan = plan || (vm.planCatalog || []).filter(function (planOption) {
                        return planOption.name === vm.selectedPlan;
                    })[0];
                    var alias = selectedPlan ?
                        (vm.billingInterval === 'year' ? selectedPlan.annualAlias : selectedPlan.monthlyAlias) :
                        null;

                    if (!alias) {
                        return;
                    }
                    $state.go('upgrade.checkout', {
                        alias: alias
                    });
                }

                function continueToProject() {
                    var destination = ctrl.redirectTo || 'app.project.wizard';
                    if (destination === 'app.project.wizard') {
                        $state.go(destination, {
                            step: 'create-project',
                            from: 'onboarding',
                            fresh: '1'
                        });
                    } else {
                        $state.go(destination);
                    }
                }
            }]
    };
});
